import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { App } from "./App"
import { AuthProvider } from "./auth/AuthContext"
import { PublicConfigProvider } from "./config/PublicConfigContext"
import "./styles/global.css"

const preference = localStorage.getItem("family-coin.theme") ?? "system"
const dark = preference === "dark" || (preference === "system" && matchMedia("(prefers-color-scheme: dark)").matches)
document.documentElement.dataset.theme = dark ? "dark" : "light"
document.documentElement.style.colorScheme = dark ? "dark" : "light"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) => {
        const status = error && typeof error === "object" && "status" in error ? Number(error.status) : 0
        return status >= 400 && status < 500 ? false : count < 2
      },
      refetchOnWindowFocus: true,
      staleTime: 15_000
    },
    mutations: { retry: false }
  }
})

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <PublicConfigProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </PublicConfigProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
)

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker
      .register("/sw.js")
      .catch((error) => console.warn("Service worker registration failed", error))
  })
}
